<template>
  <cbm-card
    title="Unidades elegíveis"
    :number-text="value"
    tooltip="Venda total dos produtos participantes da campanha que cumpriram os requisitos para ganhar o benefício"
    simple-card
    :boolean-loader="loading"
  />
</template>

<script>
import CbmCard from '@/components/CbmCard.vue'
import { localeString } from '@/config/helpers.js'

export default {
  components: {
    CbmCard,
  },
  props: {
    metrics: Object,
    loading: Boolean,
  },
  computed: {
    value() {
      return localeString(this.metrics?.eligible_metrics?.quantity || 0, 0)
    },
  },
}
</script>
